import { useEffect, useMemo, useState, useRef, useCallback } from "react";
import "./DonatePage.css";

const ITEMS = {
  "Ранги": [
    {name:"Knight",price:49,image:"/images/knight.png",description:"5 домов • Кит Рыцарь • Префикс",details:"Команды: /kit knight, /position, /workbench\nВозможности: 5 домов, префикс в чате"},
    {name:"Lord",price:99,image:"/images/lord.png",description:"10 домов • /hat • /feed • Префикс",details:"Команды: /kit lord, /hat, /feed, /itemdb\nВозможности: 10 домов, префикс в чате"},
    {name:"Paladin",price:149,image:"/images/paladin.png",description:"∞ домов • /enderchest • /ext • /clear",details:"Команды: /kit paladin, /enderchest, /ext, /clear\nВозможности: ∞ домов, префикс в чате",best:true},
    {name:"Duke",price:249,image:"/images/duke.png",description:"∞ домов • /fly • /heal • /near",details:"Команды: /kit duke, /fly, /heal, /near, /gc\nВозможности: ∞ домов, префикс в чате"},
    {name:"King",price:399,image:"/images/king.png",description:"∞ домов • /fly • /repair all • /invsee",details:"Команды: /kit king, /fly, /repair all, /invsee, /afk\nВозможности: ∞ домов, префикс в чате"},
    {name:"Emperor",price:599,image:"/images/emperor.png",description:"∞ домов • /god • /nick • 5 коинов/час",details:"Команды: /kit emperor, /god, /nick, /ptime\nВозможности: ∞ домов, префикс ꀔ, зарплата 5 коинов/час"},
    {name:"Titan",price:899,image:"/images/titan.png",description:"/hat • /speed • 3 варпа • 15 коинов/час",details:"Команды: /kit titan, /hat, /speed, /pw set (лимит 3)\nВозможности: ∞ домов, префикс ꀕ, зарплата 15 коинов/час"},
    {name:"Legend",price:1199,image:"/images/legend.png",description:"/enchant • 5 варпов • 25 коинов/час",details:"Команды: /kit legend, /enchant, /seen, /pw set (лимит 5)\nВозможности: ∞ домов, префикс ꀖ, зарплата 25 коинов/час"},
    {name:"Immortal",price:1499,image:"/images/immortal.png",description:"/spectator • 15 варпов • Иммунитет • 50/час",details:"Команды: /kit immortal, /spectator, /tpahere, /pw set (лимит 15)\nВозможности: ∞ домов, префикс ꀗ, зарплата 50 коинов/час\nИммунитет от кика, мута и бана"},
    {name:"God",price:1999,image:"/images/god.png",description:"Все команды • 30 варпов • 100 коинов/час",details:"Команды: /kit god, /kick, /ban, /mute, /broadcast, /dupeip, /whois\nВарпы: /pw set (лимит 30)\nВозможности: ∞ домов, префикс ꀘ, зарплата 100 коинов/час\nСвязь с владельцем сервера"},
  ],
  "Коробки": [
    {name:"Обычная Коробка с Рангами",price:99,image:"/images/common_case.png",description:"Шанс на Knight — King",details:"Обычная коробка с рангами:\nKnight — 35% | Lord — 25% | Paladin — 20%\nDuke — 15% | King — 5%"},
    {name:"Супер Коробка с Рангами",price:899,image:"/images/super_case.png",description:"Шанс на Emperor — God",details:"Супер коробка с топовыми рангами:\nEmperor — 35% | Titan — 25% | Legend — 20%\nImmortal — 15% | God — 5%",best:true},
    {name:"Коробка с Китами x10",price:249,image:"/images/kit_case.png",description:"10 коробок • Киты внутри",details:"Набор из 10 коробок с китами:\nБерсерк ⚔ | Снайпер 🏹 | Страж 🛡\nПризрак 💨 | Палач 💀"},
    {name:"Коробка с Коинами",price:69,image:"/images/coin_case.png",description:"Шанс на 10000 коинов",details:"Коробка с коинами:\n100 — 65% | 500 — 25% | 1500 — 8%\n5000 — 1.5% | 10000 — 0.5%",hasQty:true,qtyPrices:{1:69,5:299,10:449}},
    {name:"Коробка с Сердцами",price:79,image:"/images/heart_case.png",description:"Шанс на +20 ❤ навсегда",details:"Коробка с дополнительными сердцами:\n+2 ❤ — 40% | +5 ❤ — 30% | +10 ❤ — 18%\n+15 ❤ — 9% | +20 ❤ — 3%\nСердца добавляются навсегда!",hasQty:true,qtyPrices:{1:79,5:299,10:499}},
  ],
  "Ключи": [
    {name:"Обычный Ящик x10",price:49,image:"/images/common_crate.png",description:"10 ящиков • Базовые награды",details:"Набор из 10 обычных ящиков.\nШанс получить ресурсы, зелья и простую экипировку."},
    {name:"Редкий Ящик x10",price:99,image:"/images/rare_crate.png",description:"10 ящиков • Редкие предметы",details:"Набор из 10 редких ящиков.\nЗачарованная броня, уникальные предметы, много ресурсов.",best:true},
    {name:"Эпический Ящик x10",price:149,image:"/images/epic_crate.png",description:"10 ящиков • Топовые награды",details:"Набор из 10 эпических ящиков.\nНезеритовая экипировка, эксклюзивные предметы, питомцы."},
    {name:"Улучшенный Ящик x10",price:249,image:"/images/key.png",description:"10 ящиков • Улучшенные награды",details:"Набор из 10 улучшенных ящиков.\nЖелезная и алмазная экипировка, редкие ресурсы."},
  ],
  "Другое": [
    {name:"Размут",price:29,image:"/images/razmute.png",description:"Снятие мута с аккаунта",details:"Полное снятие мута с вашего аккаунта.\nПосле оплаты мут будет снят автоматически."},
    {name:"Разбан",price:49,image:"/images/razban.png",description:"Снятие бана с аккаунта",details:"Полное снятие бана с вашего аккаунта.\nПосле оплаты бан будет снят автоматически."},
    {name:"Приват алмазной руды",price:29,image:"/images/diamond_ruda.png",description:"Защита алмазных жил",details:"Приват блока алмазной руды.\nЗащитите свои алмазные жилы от других игроков."},
    {name:"Приват изумрудной руды",price:49,image:"/images/emerald_ruda.png",description:"Защита изумрудных жил",details:"Приват блока изумрудной руды.\nЗащитите свои изумрудные жилы от других игроков."},
    {name:"Незеритовый приват",price:79,image:"/images/netherite_ruda.png",description:"Защита незеритовых блоков",details:"Приват незеритового блока.\nМаксимальная защита самых ценных ресурсов."},
  ],
};

const CATEGORIES = ["Ранги","Коробки","Ключи","Коины","Другое"];
const COIN_PRESETS = [100, 500, 1000, 5000];

function makePlaceholder(name) {
  const initials = (name||'?').slice(0,2).toUpperCase();
  const hue = [...(name||'')].reduce((a,c)=>a+c.charCodeAt(0),0) % 360;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64"><rect width="64" height="64" rx="10" fill="hsl(${hue},40%,12%)"/><rect x="4" y="4" width="8" height="8" fill="hsl(${hue},70%,45%)" opacity=".6"/><rect x="52" y="4" width="8" height="8" fill="hsl(${hue},70%,45%)" opacity=".6"/><rect x="4" y="52" width="8" height="8" fill="hsl(${hue},70%,45%)" opacity=".6"/><rect x="52" y="52" width="8" height="8" fill="hsl(${hue},70%,45%)" opacity=".6"/><text x="32" y="38" text-anchor="middle" font-family="monospace" font-size="18" font-weight="bold" fill="hsl(${hue},70%,70%)">${initials}</text></svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

function calcRankPrice(basePrice, dur) {
  if (dur === "month") return Math.round(basePrice * 0.4);
  if (dur === "half") return Math.round(basePrice * 0.65);
  if (dur === "forever") return basePrice * 3;
  return basePrice;
}

function durLabel(dur) {
  if (dur === "month") return "1 мес";
  if (dur === "half") return "6 мес";
  if (dur === "forever") return "Навсегда";
  return "1 год";
}

/* ── Particles ── */
function Particles() {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current; if (!c) return;
    const ctx = c.getContext("2d");
    let w, h;
    const ps = [];
    const resize = () => { w = c.width = window.innerWidth; h = c.height = window.innerHeight; };
    resize(); window.addEventListener("resize", resize);
    for (let i = 0; i < 50; i++) ps.push({ x:Math.random()*w, y:Math.random()*h, s:1.5+Math.random()*2.5, vy:-(0.08+Math.random()*0.2), vx:(Math.random()-0.5)*0.25, a:0.08+Math.random()*0.18, hue:Math.random()>0.5?0:28 });
    let raf;
    const draw = () => {
      ctx.clearRect(0,0,w,h);
      ps.forEach(p => { p.x+=p.vx; p.y+=p.vy; if(p.y<-10){p.y=h+10;p.x=Math.random()*w;} if(p.x<-10)p.x=w+10; if(p.x>w+10)p.x=-10; ctx.fillStyle=`hsla(${p.hue},80%,65%,${p.a})`; ctx.fillRect(Math.round(p.x),Math.round(p.y),p.s,p.s); });
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", resize); };
  }, []);
  return <canvas id="bg-canvas" ref={ref} />;
}

/* ── Drag Coin Slider ── */
function CoinDragSlider({ coins, setCoins }) {
  const areaRef = useRef(null);
  const coinRef = useRef(null);
  const fillRef = useRef(null);
  const dragging = useRef(false);
  const startX = useRef(0);
  const startLeft = useRef(0);

  const getBounds = useCallback(() => {
    const ar = areaRef.current; if (!ar) return { minX:20, maxX:200 };
    const w = ar.getBoundingClientRect().width;
    return { minX:20, maxX:w-20-52 };
  }, []);

  const amountFromX = useCallback((x) => {
    const {minX,maxX} = getBounds();
    const t = Math.max(0, Math.min(1, (x-minX)/(maxX-minX)));
    return Math.round((100 + t*9900)/100)*100;
  }, [getBounds]);

  const updatePos = useCallback(() => {
    const coin = coinRef.current; const fill = fillRef.current;
    if (!coin || !fill) return;
    const {minX,maxX} = getBounds();
    const t = (coins-100)/9900;
    coin.style.left = (minX+t*(maxX-minX))+"px";
    fill.style.width = (t*100)+"%";
  }, [coins, getBounds]);

  useEffect(() => { updatePos(); }, [coins, updatePos]);
  useEffect(() => { window.addEventListener("resize", updatePos); return () => window.removeEventListener("resize", updatePos); }, [updatePos]);

  const onStart = useCallback((clientX) => {
    dragging.current = true; startX.current = clientX;
    const {minX} = getBounds();
    startLeft.current = parseFloat(coinRef.current?.style.left) || minX;
    coinRef.current?.classList.add("dragging");
  }, [getBounds]);

  const onMove = useCallback((clientX) => {
    if (!dragging.current) return;
    const dx = clientX - startX.current;
    const {minX,maxX} = getBounds();
    const cl = Math.max(minX, Math.min(maxX, startLeft.current+dx));
    if (coinRef.current) coinRef.current.style.left = cl+"px";
    if (fillRef.current) fillRef.current.style.width = ((cl-minX)/(maxX-minX)*100)+"%";
    setCoins(amountFromX(cl));
  }, [getBounds, amountFromX, setCoins]);

  const onEnd = useCallback(() => {
    if (!dragging.current) return;
    dragging.current = false;
    coinRef.current?.classList.remove("dragging");
  }, []);

  useEffect(() => {
    const mm = (e) => { if(dragging.current) onMove(e.clientX); };
    const tm = (e) => { if(dragging.current){e.preventDefault();onMove(e.touches[0].clientX);} };
    window.addEventListener("mousemove", mm);
    window.addEventListener("mouseup", onEnd);
    window.addEventListener("touchmove", tm, {passive:false});
    window.addEventListener("touchend", onEnd);
    return () => { window.removeEventListener("mousemove",mm); window.removeEventListener("mouseup",onEnd); window.removeEventListener("touchmove",tm); window.removeEventListener("touchend",onEnd); };
  }, [onMove, onEnd]);

  return (
    <div className="drag-coin-area" ref={areaRef}>
      <div className="drag-track"><div className="drag-track-fill" ref={fillRef} /></div>
      <img className="drag-coin" ref={coinRef} src="images/coin.png" alt="coin" draggable="false"
        onMouseDown={(e)=>{e.preventDefault();onStart(e.clientX);}}
        onTouchStart={(e)=>{e.preventDefault();onStart(e.touches[0].clientX);}}
      />
      <div className="drag-coin-label">← Тяни монету →</div>
    </div>
  );
}

/* ── MAIN ── */
export default function DonatePage() {
  const [selectedCat, setSelectedCat] = useState("Ранги");
  const [selectedItem, setSelectedItem] = useState(null);
  const [coins, setCoins] = useState(500);
  const [nickname, setNickname] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [paying, setPaying] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [copied, setCopied] = useState(false);
  const [duration, setDuration] = useState("year");
  const [caseQty, setCaseQty] = useState(1);
  const [online, setOnline] = useState(null);
  const heroRef = useRef(null);

  const currentItems = useMemo(() => ITEMS[selectedCat] || [], [selectedCat]);
  const coinPrice = Math.round(coins * 0.15);

  useEffect(() => {
    if (selectedCat === "Коины") { setSelectedItem(null); return; }
    setSelectedItem(currentItems[0] || null);
  }, [selectedCat, currentItems]);

  // Fetch online count
  useEffect(() => {
    const fetchOnline = () => {
      fetch("/api/online").then(r=>r.json()).then(d=>{ if(d.online!==undefined) setOnline(d); }).catch(()=>{});
    };
    fetchOnline();
    const interval = setInterval(fetchOnline, 30000);
    return () => clearInterval(interval);
  }, []);

  // Payment status from URL
  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const s = p.get("status");
    if (s === "success" || s === "fail") { setPaymentStatus(s); window.history.replaceState({}, "", window.location.pathname); }
  }, []);

  // Parallax
  useEffect(() => {
    const onScroll = () => {
      if (!heroRef.current) return;
      const y = window.scrollY;
      heroRef.current.style.transform = `translateY(${y*0.18}px)`;
      heroRef.current.style.opacity = Math.max(0, 1-y/400);
    };
    window.addEventListener("scroll", onScroll, {passive:true});
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const copyIp = () => { navigator.clipboard.writeText("mc.bugmine.pw").then(()=>{ setCopied(true); setTimeout(()=>setCopied(false),2000); }); };

  const handleBuy = () => { setDuration("year"); setCaseQty(1); setShowModal(true); };

  const getModalPrice = () => {
    if (selectedCat === "Коины") return coinPrice;
    if (selectedCat === "Ранги") return calcRankPrice(selectedItem?.price || 0, duration);
    if (selectedItem?.hasQty) return selectedItem.qtyPrices[caseQty] || selectedItem.price * caseQty;
    return selectedItem?.price || 0;
  };

  const handleConfirmPay = async () => {
    if (!nickname.trim() || paying) return;
    setPaying(true);
    try {
      const amount = getModalPrice();
      const item = selectedCat === "Коины" ? `${coins}_coins` : selectedItem?.hasQty ? `${selectedItem.name} x${caseQty}` : selectedItem?.name;
      const durValue = selectedCat === "Ранги" ? duration : undefined;
      const res = await fetch("/api/order/create", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nickname: nickname.trim(),
          category: selectedCat,
          item,
          amount,
          coins: selectedCat === "Коины" ? coins : undefined,
          duration: durValue,
        }),
      });
      const data = await res.json();
      if (data.payUrl) { window.open(data.payUrl, "_blank"); setShowModal(false); }
      else alert("Ошибка создания заказа");
    } catch { alert("Ошибка соединения с сервером"); }
    finally { setPaying(false); }
  };

  const onImgError = (e, name) => { e.target.onerror=null; e.target.src=makePlaceholder(name); };

  return (
    <div className="donate-page" style={{ backgroundImage: "url('/fon.svg')" }}>
      <Particles />
      <div className="bg-overlay" />
      <div className="scanlines" />

      <div className="shell">
        {/* HERO */}
        <header className="hero" ref={heroRef}>
          <div className="hero-left">
            <span className="eyebrow">Игровой магазин</span>
            <h1 className="hero-title">Автодонат BugMine</h1>
            <p className="hero-sub">Все покупки выдаются автоматически сразу после оплаты.</p>
            <div className="hero-actions">
              <button type="button" className="ip-btn" onClick={copyIp}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                <span>{copied ? "Скопировано!" : "mc.bugmine.pw"}</span>
              </button>
              <a href="https://vk.com/bug_mine" target="_blank" rel="noopener noreferrer" className="social-btn vk">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M21.547 7h-3.29a.743.743 0 0 0-.655.392s-1.312 2.416-1.734 3.23C14.734 12.813 14 12.126 14 11.11V7.603A1.104 1.104 0 0 0 12.896 6.5h-2.474a1.982 1.982 0 0 0-1.75.813s1.255-.204 1.255 1.49c0 .42.022 1.626.04 2.64a.73.73 0 0 1-1.272.503 21.54 21.54 0 0 1-2.498-4.543.693.693 0 0 0-.63-.403h-2.99a.508.508 0 0 0-.48.685C3.005 10.175 6.918 18 11.38 18h1.878a.742.742 0 0 0 .742-.742v-1.135a.73.73 0 0 1 1.23-.53l2.247 2.112a1.09 1.09 0 0 0 .746.295h2.953c1.424 0 1.424-.988.647-1.753-.546-.538-2.518-2.617-2.518-2.617a1.02 1.02 0 0 1-.078-1.323c.637-.84 1.68-2.212 2.122-2.8.603-.804 1.697-2.507.197-2.507z"/></svg>
                VK
              </a>
              <a href="https://discord.com/invite/BnSSH3ADCV" target="_blank" rel="noopener noreferrer" className="social-btn ds">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/></svg>
                Discord
              </a>
            </div>
          </div>
          <div className="hero-right">
            <div className="hero-badge">⚡ Мгновенная выдача</div>
            <div className="online-badge"><span className="online-dot" /> Онлайн: {online ? `${online.online}/${online.max}` : "—"}</div>
          </div>
        </header>

        {/* CATEGORIES */}
        <div className="panel category-section">
          <div className="category-row">
            {CATEGORIES.map(cat => (
              <button key={cat} type="button" className={`cat-chip ${selectedCat===cat?"active":""}`} onClick={()=>setSelectedCat(cat)}>{cat}</button>
            ))}
          </div>
        </div>

        {/* CATALOG */}
        <div className="catalog">
          <div className="panel items-panel">
            {selectedCat !== "Коины" ? (
              <div className="items-list">
                {currentItems.map(item => (
                  <button key={item.name} type="button" className={`item-card ${selectedItem?.name===item.name?"active":""}`} onClick={()=>setSelectedItem(item)}>
                    <img className="item-img" src={item.image} alt={item.name} onError={(e)=>onImgError(e,item.name)} />
                    <div className="item-info">
                      <div className="item-name">{item.name}{item.best && <span className="best-badge">🔥 BEST</span>}</div>
                      <div className="item-desc">{item.description}</div>
                    </div>
                    <span className="item-price">{item.price}₽</span>
                  </button>
                ))}
              </div>
            ) : (
              <div className="coins-block">
                <div className="coins-title">Выберите количество коинов</div>
                <div className="coin-presets">
                  {COIN_PRESETS.map(p => (
                    <button key={p} type="button" className={`coin-preset ${coins===p?"active":""}`} onClick={()=>setCoins(p)}>
                      <span className="preset-amount">{p}</span>
                      <span className="preset-price">{Math.round(p*0.15)}₽</span>
                    </button>
                  ))}
                </div>
                <CoinDragSlider coins={coins} setCoins={setCoins} />
                <div className="coins-display">
                  <span className="cd-amount">{coins} коинов</span>
                  <span className="cd-price">{coinPrice}₽</span>
                </div>
              </div>
            )}
          </div>

          {/* DETAILS */}
          <div className="panel details-panel">
            <div className="details-inner">
              {selectedCat === "Коины" ? (
                <>
                  <div className="coins-details-box">
                    <img className="coin-big" src="images/coin.png" alt="coin" />
                    <h2>Покупка коинов</h2>
                    <p>Используйте коины для покупок на сервере в любое время.</p>
                  </div>
                  <div className="purchase-box" style={{marginTop:"auto"}}>
                    <div className="purchase-row"><span className="purchase-label">Количество</span><span style={{fontFamily:"'Silkscreen',monospace",fontSize:14}}>{coins} коинов</span></div>
                    <div className="purchase-row"><span className="purchase-label">Цена</span><span className="purchase-price">{coinPrice}₽</span></div>
                    <button type="button" className="pay-btn" onClick={handleBuy}>Купить</button>
                  </div>
                </>
              ) : selectedItem ? (
                <>
                  <div className={`details-img-wrap ${selectedCat==="Коробки"?"details-img-large":""}`}>
                    <img className={`details-img ${selectedCat==="Коробки"?"img-large":""}`} src={selectedItem.image} alt={selectedItem.name} onError={(e)=>onImgError(e,selectedItem.name)} />
                  </div>
                  <div className="details-text">
                    <h2>{selectedItem.name}</h2>
                    {(selectedItem.details||selectedItem.description).split("\n").map((l,i)=><p key={i}>{l}</p>)}
                  </div>
                  <div className="purchase-box">
                    <div className="purchase-row"><span className="purchase-label">Цена</span><span className="purchase-price">{selectedItem.price}₽</span></div>
                    <button type="button" className="pay-btn" onClick={handleBuy}>Купить</button>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <footer className="footer">
          <div className="footer-top">
            <div><div className="footer-logo">BugMine</div><p className="footer-tagline">Minecraft-сервер с уникальным геймплеем. Играй, развивайся, побеждай.</p></div>
            <div><div className="footer-heading">Контакты</div><ul className="footer-links"><li><span className="footer-label">Email: </span>olehkubich@gmail.com</li><li><span className="footer-label">Тел: </span>+48 883 476 548</li><li><span className="footer-label">Сервер: </span>mc.bugmine.pw</li><li><span className="footer-label">Discord: </span><a href="https://discord.com/invite/BnSSH3ADCV" target="_blank" rel="noopener noreferrer">Поддержка</a></li></ul></div>
            <div><div className="footer-heading">Документы</div><ul className="footer-links"><li><a href="/terms.html">Договор оферты</a></li><li><a href="/privacy.html">Политика конфиденциальности</a></li><li><a href="/refund.html">Условия возврата</a></li></ul></div>
            <div><div className="footer-heading">Сообщество</div><ul className="footer-links"><li><a href="https://vk.com/bug_mine" target="_blank" rel="noopener noreferrer">ВКонтакте</a></li><li><a href="https://discord.com/invite/BnSSH3ADCV" target="_blank" rel="noopener noreferrer">Discord</a></li></ul></div>
          </div>
          <div className="footer-bottom">
            <p>© {new Date().getFullYear()} BugMine. Все права защищены. Не является публичной офертой.</p>
            <p>Все товары являются виртуальными и предоставляются в рамках игрового сервера.</p>
            <p>Minecraft — зарегистрированная торговая марка Mojang Studios. Мы не связаны с Mojang или Microsoft.</p>
          </div>
        </footer>
      </div>

      {/* NICKNAME MODAL */}
      {showModal && (
        <div className="modal-overlay" onClick={()=>setShowModal(false)}>
          <div className="modal-box" onClick={e=>e.stopPropagation()}>
            <h3 className="modal-title">Введите никнейм</h3>
            <p className="modal-desc">Укажите ваш ник на сервере для получения покупки</p>
            <input type="text" className="modal-input" placeholder="Ваш никнейм..." value={nickname} onChange={e=>setNickname(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handleConfirmPay()} autoFocus autoComplete="off" />

            {selectedCat === "Ранги" && (
              <div className="duration-selector">
                <div className="duration-label">Срок действия</div>
                <div className="duration-options">
                  <button type="button" className={`duration-btn ${duration==="month"?"active":""}`} onClick={()=>setDuration("month")}>
                    <span className="dur-name">1 месяц</span>
                    <span className="dur-price">{calcRankPrice(selectedItem?.price||0,"month")}₽</span>
                  </button>
                  <button type="button" className={`duration-btn ${duration==="half"?"active":""}`} onClick={()=>setDuration("half")}>
                    <span className="dur-name">6 месяцев</span>
                    <span className="dur-price">{calcRankPrice(selectedItem?.price||0,"half")}₽</span>
                  </button>
                  <button type="button" className={`duration-btn ${duration==="year"?"active":""}`} onClick={()=>setDuration("year")}>
                    <span className="dur-name">1 год</span>
                    <span className="dur-price">{selectedItem?.price||0}₽</span>
                  </button>
                  <button type="button" className={`duration-btn forever ${duration==="forever"?"active":""}`} onClick={()=>setDuration("forever")}>
                    <span className="dur-name">Навсегда</span>
                    <span className="dur-price">{calcRankPrice(selectedItem?.price||0,"forever")}₽</span>
                  </button>
                </div>
              </div>
            )}

            {selectedItem?.hasQty && (
              <div className="duration-selector">
                <div className="duration-label">Количество</div>
                <div className="duration-options">
                  {Object.entries(selectedItem.qtyPrices).map(([qty, price]) => (
                    <button key={qty} type="button" className={`duration-btn ${caseQty===Number(qty)?"active":""}`} onClick={()=>setCaseQty(Number(qty))}>
                      <span className="dur-name">{qty} шт</span>
                      <span className="dur-price">{price}₽</span>
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div className="modal-summary">
              <span className="modal-item-name">
                {selectedCat==="Коины" ? `${coins} коинов` : selectedItem?.hasQty ? `${selectedItem.name} x${caseQty}` : selectedItem?.name||""}
                {selectedCat==="Ранги" && <span className="modal-dur-tag"> • {durLabel(duration)}</span>}
              </span>
              <span className="modal-item-price">{getModalPrice()}₽</span>
            </div>
            <div className="modal-actions">
              <button type="button" className="modal-cancel" onClick={()=>setShowModal(false)}>Отмена</button>
              <button type="button" className="pay-btn modal-pay" onClick={handleConfirmPay} disabled={!nickname.trim()||paying}>{paying?"Создание заказа...":"Оплатить"}</button>
            </div>
          </div>
        </div>
      )}

      {/* STATUS MODAL */}
      {paymentStatus && (
        <div className="modal-overlay" onClick={()=>setPaymentStatus(null)}>
          <div className={`modal-box status-modal ${paymentStatus==="success"?"status-success":"status-fail"}`} onClick={e=>e.stopPropagation()}>
            <div className="status-icon">{paymentStatus==="success"?"✅":"❌"}</div>
            <h3 className="modal-title">{paymentStatus==="success"?"Оплата прошла успешно!":"Ошибка оплаты"}</h3>
            <p className="modal-desc">{paymentStatus==="success"?"Спасибо за покупку! Товар будет выдан автоматически. Зайдите на сервер для получения.":"Платёж был отменён или произошла ошибка. Попробуйте снова или свяжитесь с нами."}</p>
            <button type="button" className={`pay-btn ${paymentStatus==="success"?"success-pay-btn":""}`} onClick={()=>setPaymentStatus(null)} style={{width:"100%"}}>{paymentStatus==="success"?"Отлично!":"Попробовать снова"}</button>
          </div>
        </div>
      )}
    </div>
  );
}